
import React, { useState, useEffect } from 'react';
import { GatsbyImage } from "gatsby-plugin-image";

import './image.scss';
import classNames from 'classnames';


export default (props) => {
  // console.log(props)
  const [data, setData] = useState(null);
  useEffect(() => {
    setData({
      img: {
        src: props.props.relationships.field_image.relationships
          .field_media_image.localFile,
        alt: props.props.relationships.field_image.field_media_image
          .alt,
        fluid: props.props.field_fluid,
      },
    });
  }, [
    props.props.relationships.field_image.relationships
      .field_media_image.localFile,
    props.props.relationships.field_image.field_media_image.alt,
    props.props.field_fluid,
  ]);

  if (data) {
    if (isSvg(data.img.src)) {
      return (
        <img
          {...props}
          alt={data.img.alt}
          src={data.img.src.publicURL}
          className={classNames('svg', {
            fluid: data.img.fluid,
          })}
        />
      );
    } else {
      return (
        <GatsbyImage
          image={{ ...data.img.src.childImageSharp.gatsbyImageData }}
          {...props}
          alt={data.img.alt}
          imgStyle={{ objectFit: 'cover' }}
          className={`d-block w-100`} />
      );
    }
  } else {
    return null;
  }
};

const isSvg = (src) => {
  return src.childImageSharp ? false : true;
};
